export type Features = {
  dozynki: boolean;
};

/** Fallback lokalny — NIE jest mechanizmem wyłączenia za ~3 tygodnie. */
export const DEFAULT_FEATURES: Features = {
  dozynki: true,
};
